import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import useViewModel from './ViewModel'
import PileList from './Components/PileList'
import ShippingOrderList from './Components/ShippingOrderList'

const ShippingFormView: React.FC = () => {
  const {
    isCreate,
    formik,
    isView,
    paramProjectId,
    handleClose,
    PILE_ITEMS_CONFIGS,
    SHIPPING_ORDER_LIST_CONFIGS,
    staticShippingRequest,
    hasItemInvalid,
    shippingOrders,
    shippingRequest,
  } = useViewModel()

  return (
    <ViewPageTitle isCreate={isCreate} isView={isView}>
      <div className='mb-5'>
        <PageBreadCrumb statusTitle={staticShippingRequest.status ?? ''} />
      </div>

      <div className='card'>
        <form
          onSubmit={(e: any) => {
            formik.handleSubmit(e)
            e.preventDefault()
          }}>
          <div className='card-body py-lg-10 px-lg-10'>
            <div className='row gy-3'>
              {/* begin:: Sale Order */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='saleOrderCode' className='fs-6 mb-3'>
                  ใบสั่งขาย
                  <span className='required' />
                </label>
                <input
                  disabled
                  id='saleOrderCode'
                  name='saleOrderCode'
                  value={staticShippingRequest.saleOrderCode ?? ''}
                  className='form-control form-control-sm'
                />
              </div>
              {/* end:: Sale Order */}

              {/* begin:: Division */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='division' className='fs-6 mb-3'>
                  หน่วยงาน
                  <span className='required' />
                </label>

                <input
                  disabled
                  name='division'
                  id='division'
                  value={staticShippingRequest?.division ?? ''}
                  className='form-control form-control-sm'
                />
              </div>
              {/* end:: Division */}

              {/* begin:: Customer Title */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='customerTitle' className='fs-6 mb-3'>
                  ชื่อลูกค้า
                  <span className='required' />
                </label>

                <input
                  name='customerTitle'
                  id='customerTitle'
                  disabled
                  value={staticShippingRequest?.customerTitle ?? ''}
                  className='form-control form-control-sm'
                />
              </div>
              {/* end:: Customer Title */}

              {/* begin:: Customer Title */}
              <div className='col-12 '>
                <label htmlFor='requestMessage' className='fs-6 mb-3'>
                  รายละเอียดคำร้อง
                  <span className='required' />
                </label>

                <textarea
                  rows={5}
                  className='form-control form-control-sm'
                  disabled={isView}
                  {...formik.getFieldProps('requestMessage')}
                />
              </div>
              {/* end:: Customer Title */}

              {/* <PileList
                PILE_ITEMS_CONFIGS={PILE_ITEMS_CONFIGS}
                isView={isView}
                addPile={() => {}}
                formik={formik}
              /> */}
            </div>
          </div>

          <div className='card-footer'>
            {!isView && isCreate && (
              <div
                className='col-12 d-flex flex-row justify-content-end'
                style={{ columnGap: '12px' }}>
                <button
                  type='reset'
                  className='btn btn-sm btn-light fw-bolder'
                  onClick={handleClose}
                  disabled={formik.isSubmitting}>
                  ยกเลิก
                </button>
                <button
                  type='submit'
                  className='btn btn-sm btn-success me-4 fw-bold'
                  disabled={formik.isSubmitting || !formik.isValid || hasItemInvalid}>
                  บันทึก
                </button>
              </div>
            )}
          </div>
        </form>
      </div>

      {!isCreate && (
        <div className='card mt-5'>
          <div className='card-body mt-5 py-lg-10 px-lg-10'>
            <ShippingOrderList
              SHIPPING_ORDER_LIST_CONFIGS={SHIPPING_ORDER_LIST_CONFIGS}
              shippingRequestId={shippingRequest.id}
              shippingorders={shippingOrders}
              viewOnly={paramProjectId ?? null}
            />
          </div>
        </div>
      )}
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren & { isCreate: boolean; isView: boolean }> = ({
  children,
  isCreate,
  isView,
}) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '/shipping-request',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/ecommerce/ecm006.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'คำขอการขนส่ง',
            icon: '/media/icons/duotune/ecommerce/ecm006.svg',
          },
        ]}>
        {isView ? 'รายละเอียดคำขอการขนส่ง' : isCreate ? 'สร้างคำขอการขนส่ง' : 'แก้ไขคำขอการขนส่ง'}
      </PageTitle>

      {children}
    </>
  )
}

export default ShippingFormView
